import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { Text } from '@chakra-ui/react';

import { Container } from './Container';
import { TabsMenu } from './TabsMenu';
import { useIsTablet } from '../../hooks/isTablet';

interface NameLiProps {
  onClick?: (index: number) => void;
  index: number;
  handleCloseModal?: () => void;
  isActive: boolean;
  tabName: string;
  disabled: boolean;
}

class NameLi extends React.Component<NameLiProps> {
  handleClick = () => {
    const { onClick, index, handleCloseModal } = this.props;
    handleCloseModal && handleCloseModal();
    onClick && onClick(index);
  };

  handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.handleClick();
    }
  };

  render() {
    const { isActive, tabName, disabled } = this.props;
    return (
      <li
        className={classNames({ active: isActive, disabled })}
        onClick={this.handleClick}
        onKeyDown={!disabled ? this.handleKeyDown : undefined}
        tabIndex={disabled ? -1 : 0}
        role="tab"
        aria-selected={isActive}
        aria-disabled={disabled}
      >
        <Text as="div" textStyle="caption" className="caption">
          {tabName}
        </Text>
      </li>
    );
  }
}

interface TabsProps {
  tabNames: any[];
  disabledIndexes?: number[];
  activeIndex: number;
  onClick: (index: number) => void;
  style?: any;
}

const MAX_TABS_FOR_DROPDOWN = 8;

export const Tabs: React.FC<TabsProps> = ({ tabNames, disabledIndexes = [], activeIndex, onClick }) => {
  const isTablet = useIsTablet();
  const moduloActiveIndex = Math.abs(activeIndex % tabNames.length);
  
  const shouldShowDropdown = isTablet || tabNames.length > MAX_TABS_FOR_DROPDOWN;
  
  return (
    <Container style={{ marginBottom: '12px' }}>
      {shouldShowDropdown ? (
        // if mobile, tablet or many tabs --> show dropdown
        <TabsMenu
          className=""
          activeIndex={moduloActiveIndex}
          activeTab={tabNames[moduloActiveIndex]!}
          disabledIndexes={disabledIndexes}
          tabs={tabNames}
          onClick={onClick}
        />
      ) : (
        // if desktop with few tabs --> show normal tabs
        <ul role="tablist">
          {tabNames.map((tabName, i) => (
            <NameLi
              key={i}
              tabName={tabName}
              disabled={disabledIndexes.includes(i)}
              isActive={i === moduloActiveIndex}
              index={i}
              onClick={!disabledIndexes.includes(i) ? onClick : undefined}
            />
          ))}
        </ul>
      )}
    </Container>
  );
};
